// Single source of truth for country metadata used across slides and the Globe.
// iso2: two-letter code (CircleFlag); ll: [lon, lat] centre; dot: Globe small-dot class or null.
export const COUNTRIES = {
  ATG: { iso2: 'ag', name: 'Antigua and Barbuda', ll: [-61.8, 17.1], dot: 'sids' },
  BGD: { iso2: 'bd', name: 'Bangladesh', ll: [90.4, 23.7], dot: null },
  BEN: { iso2: 'bj', name: 'Benin', ll: [2.3, 9.3], dot: null },
  BFA: { iso2: 'bf', name: 'Burkina Faso', ll: [-1.6, 12.2], dot: null },
  BHR: { iso2: 'bh', name: 'Bahrain', ll: [50.6, 26.0], dot: 'sids' },
  BLZ: { iso2: 'bz', name: 'Belize', ll: [-88.5, 17.2], dot: null },
  BRB: { iso2: 'bb', name: 'Barbados', ll: [-59.5, 13.2], dot: 'sids' },
  CAF: { iso2: 'cf', name: 'Central African Republic', ll: [20.9, 6.6], dot: null },
  KHM: { iso2: 'kh', name: 'Cambodia', ll: [104.9, 12.5], dot: null },
  COM: { iso2: 'km', name: 'Comoros', ll: [43.3, -11.7], dot: 'dual' },
  COK: { iso2: 'ck', name: 'Cook Islands', ll: [-159.8, -21.2], dot: 'sids' },
  CPV: { iso2: 'cv', name: 'Cabo Verde', ll: [-23.6, 16.5], dot: 'sids' },
  DJI: { iso2: 'dj', name: 'Djibouti', ll: [42.5, 11.7], dot: null },
  DMA: { iso2: 'dm', name: 'Dominica', ll: [-61.4, 15.4], dot: 'sids' },
  DOM: { iso2: 'do', name: 'Dominican Republic', ll: [-70.7, 19.0], dot: null },
  FJI: { iso2: 'fj', name: 'Fiji', ll: [178.0, -17.7], dot: null },
  FSM: { iso2: 'fm', name: 'Micronesia (Federated States of)', ll: [158.2, 6.9], dot: 'sids' },
  GMB: { iso2: 'gm', name: 'Gambia', ll: [-15.4, 13.4], dot: null },
  GRD: { iso2: 'gd', name: 'Grenada', ll: [-61.7, 12.1], dot: 'sids' },
  JAM: { iso2: 'jm', name: 'Jamaica', ll: [-77.3, 18.1], dot: null },
  KIR: { iso2: 'ki', name: 'Kiribati', ll: [173.0, 1.4], dot: 'dual' },
  KNA: { iso2: 'kn', name: 'Saint Kitts and Nevis', ll: [-62.7, 17.3], dot: 'sids' },
  LAO: { iso2: 'la', name: "Lao People's Democratic Republic", ll: [102.5, 18.0], dot: null },
  LBR: { iso2: 'lr', name: 'Liberia', ll: [-9.4, 6.4], dot: null },
  LCA: { iso2: 'lc', name: 'Saint Lucia', ll: [-60.9, 13.9], dot: 'sids' },
  LSO: { iso2: 'ls', name: 'Lesotho', ll: [28.2, -29.6], dot: null },
  MDV: { iso2: 'mv', name: 'Maldives', ll: [73.2, 3.2], dot: 'sids' },
  MHL: { iso2: 'mh', name: 'Marshall Islands', ll: [171.4, 7.1], dot: 'sids' },
  MLI: { iso2: 'ml', name: 'Mali', ll: [-3.9, 17.6], dot: null },
  MMR: { iso2: 'mm', name: 'Myanmar', ll: [95.9, 21.9], dot: null },
  MOZ: { iso2: 'mz', name: 'Mozambique', ll: [35.5, -18.6], dot: null },
  MRT: { iso2: 'mr', name: 'Mauritania', ll: [-10.9, 21.0], dot: null },
  MUS: { iso2: 'mu', name: 'Mauritius', ll: [57.6, -20.3], dot: 'sids' },
  MWI: { iso2: 'mw', name: 'Malawi', ll: [34.3, -13.3], dot: null },
  NIU: { iso2: 'nu', name: 'Niue', ll: [-169.9, -19.1], dot: 'sids' },
  NPL: { iso2: 'np', name: 'Nepal', ll: [84.1, 28.4], dot: null },
  NRU: { iso2: 'nr', name: 'Nauru', ll: [166.9, -0.5], dot: 'sids' },
  PLW: { iso2: 'pw', name: 'Palau', ll: [134.6, 7.5], dot: 'sids' },
  SEN: { iso2: 'sn', name: 'Senegal', ll: [-14.5, 14.5], dot: null },
  SLB: { iso2: 'sb', name: 'Solomon Islands', ll: [160.0, -9.7], dot: null },
  STP: { iso2: 'st', name: 'São Tomé and Príncipe', ll: [6.6, 0.2], dot: 'dual' },
  SYC: { iso2: 'sc', name: 'Seychelles', ll: [55.5, -4.7], dot: 'sids' },
  TGO: { iso2: 'tg', name: 'Togo', ll: [1.2, 8.7], dot: null },
  TON: { iso2: 'to', name: 'Tonga', ll: [-175.2, -21.2], dot: 'sids' },
  TUV: { iso2: 'tv', name: 'Tuvalu', ll: [179.2, -8.5], dot: 'dual' },
  TZA: { iso2: 'tz', name: 'United Republic of Tanzania', ll: [34.9, -6.4], dot: null },
  UGA: { iso2: 'ug', name: 'Uganda', ll: [32.3, 1.4], dot: null },
  VCT: { iso2: 'vc', name: 'Saint Vincent and the Grenadines', ll: [-61.2, 13.2], dot: 'sids' },
  VUT: { iso2: 'vu', name: 'Vanuatu', ll: [167.8, -16.0], dot: null },
  WSM: { iso2: 'ws', name: 'Samoa', ll: [-171.8, -13.8], dot: 'sids' },
  ZMB: { iso2: 'zm', name: 'Zambia', ll: [27.8, -13.1], dot: null }
};
